// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tzHsn","icon":"styles_icon__1Fk7W"};